import React, { PropsWithChildren } from 'react'
import { concatStyles, remCalc } from 'utils'

interface IIndicatorProps {
  color?: string
  size: number
  disabled?: boolean
  onClick: Function
}

const INDICATOR_STYLES =
  'cursor-pointer opacity-100 relative bg-transparent border-2 border-solid border-body border-opacity-25 hover:border-actionable hover:border-opacity-25 rounded-full'
const DISABLED_STYLES = 'opacity-50'

export const Indicator: React.FC<PropsWithChildren<IIndicatorProps>> = ({
  color,
  size,
  disabled,
  onClick,
  children,
}) => {
  const handleOnClick = () => onClick?.()

  const INDICATOR_INLINE_STYLES = {
    backgroundColor: color,
    height: remCalc(size),
    width: remCalc(size),
  }
  return (
    <div
      onClick={handleOnClick}
      style={INDICATOR_INLINE_STYLES}
      className={concatStyles([
        INDICATOR_STYLES,
        disabled ? DISABLED_STYLES : '',
      ])}
    >
      {children}
    </div>
  )
}
